import { render, staticRenderFns } from "./GridGreatness.vue?vue&type=template&id=3bfc58ac&scoped=true&"
import script from "./GridGreatness.vue?vue&type=script&lang=js&"
export * from "./GridGreatness.vue?vue&type=script&lang=js&"
import style0 from "./GridGreatness.vue?vue&type=style&index=0&id=3bfc58ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfc58ac",
  null
  
)

export default component.exports